/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Order_Success_TitleInputs */

const vi_pos_order_success_title = /** @type {(inputs: Pos_Order_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt hàng thành công!`)
};

/**

* @param {Pos_Order_Success_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_order_success_title = /** @type {((inputs?: Pos_Order_Success_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Order_Success_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_order_success_title(inputs)
});